import { API_URL } from '../../constants/constants.js';
import axios from "axios";


export default class ClientesProvider {
  static async getClientes() {
    let response = await axios.get(
      API_URL + "/api/clientes"
    );
    return response.data.data.clientes;
  }

  static async newCliente(cliente) {
    const respuesta = await axios.post(
      API_URL + "/api/clientes",
      cliente
    );
    return respuesta.data.idCliente
  }

}
